"use client";
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const context = createContext({
    translate: () => '',
    locale: 'ar',
    appType: 'web',
    platform: 'web',
    isRtlLocale: true,
});
context.displayName = 'AppPlatformContext';
/**
 * @class AppContextFactory
 * @description initiate the app context to be used in project specific product logic library.
 * Doing that through the factory class allow a dynamic set of options to be set and consumed everywhere
 * inside the product logic library. The context itself should wrap all the apps for example "ReactNative and Website"
 * to provide the required values for the logic library
 */
class AppContextFactory {
    constructor({ initializeHook, } = {}) {
        this.initializeHook = () => undefined;
        this.AppPlatformContextProvider = (_a) => {
            var { children } = _a, props = __rest(_a, ["children"]);
            const { locale, platform } = props;
            const isRtlLocale = locale === 'ar';
            const appType = platform !== 'web' ? 'web' : 'app';
            this.initializeHook(props);
            return (jsx(context.Provider, { value: Object.assign(Object.assign(Object.assign({}, props), { isRtlLocale,
                    appType }), props), children: children }));
        };
        this.useAppPlatformContextOptions = () => {
            return useContext(context);
        };
        if (initializeHook) {
            this.initializeHook = initializeHook;
        }
    }
}
/** useAppPlatformContextOptions to be used internally in the ui utilities only */
const useAppPlatformContextOptions = () => {
    return useContext(context);
};

export { AppContextFactory, useAppPlatformContextOptions };
